import * as types from 'actions/types';
import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {
  escRecoSeenForTickets: [],
  activeEscRecoPopupId: null,
};

const escalationRecommendation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_ACTIVE_ESC_RECO_POPUP_ID:
      return dotProp.set(state, 'activeEscRecoPopupId', action.payload);
    case types.SET_ESC_RECO_SEEN:
      return dotProp.set(state, 'escRecoSeenForTickets', [...state.escRecoSeenForTickets, action.conversationObjId]);
    default:
      return state;
  }
};

export default escalationRecommendation;
